module.exports = __webpack_public_path__ + "img/how-to-img01.f2577f8a.png";